module.exports = __webpack_public_path__ + "static/media/YFIe.d7418691.png";